import { createContext } from 'react';
const AppContext = createContext();

export const AppProvider = ({ children }) => (
  <AppContext.Provider value={{ newArr: [] }}>{children}</AppContext.Provider>
);

export default AppContext;
